var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 109,
    viewBox: "0 0 397 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.193 68.9594V38.5934H148.027C155.529 38.5934 160.174 42.3891 160.174 48.7749C160.174 55.2947 155.485 59.0458 148.116 59.0458H143.338V68.9594H136.193ZM147.893 44.2647H143.338V53.3745H147.715C151.198 53.3745 152.805 51.5436 152.805 48.8196C152.805 46.0509 151.108 44.2647 147.893 44.2647Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.832 68.9594V44.9345H170.665V48.2837C172.183 45.4257 174.505 44.1754 176.961 44.1754C177.944 44.1754 178.837 44.4433 179.328 44.9345V50.6951C178.524 50.5165 177.676 50.4272 176.604 50.4272C172.495 50.4272 170.665 52.7493 170.665 56.5451V68.9594H163.832Z",
    fill: "#181818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.061 42.5231V36.8071H188.893V42.5231H182.061ZM182.061 68.9594V44.9345H188.893V68.9594H182.061Z",
    fill: "#181818"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.249 69.6739C196.97 69.6739 192.459 64.8511 192.459 56.947C192.459 48.7749 197.104 44.1754 204.249 44.1754C211.528 44.1754 216.082 49.0875 216.082 56.947C216.082 65.0743 211.394 69.6739 204.249 69.6739ZM204.249 64.1366C207.419 64.1366 209.071 61.6358 209.071 56.947C209.071 52.3027 207.375 49.7127 204.249 49.7127C201.123 49.7127 199.47 52.2581 199.47 56.947C199.47 61.5912 201.167 64.1366 204.249 64.1366Z",
    fill: "#181818"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.696 68.9594V44.9345H226.528V48.2837C228.046 45.4257 230.369 44.1754 232.825 44.1754C233.807 44.1754 234.7 44.4433 235.191 44.9345V50.6951C234.388 50.5165 233.539 50.4272 232.467 50.4272C228.359 50.4272 226.528 52.7493 226.528 56.5451V68.9594H219.696Z",
    fill: "#181818"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.924 42.5231V36.8071H244.757V42.5231H237.924ZM237.924 68.9594V44.9345H244.757V68.9594H237.924Z",
    fill: "#181818"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M250.243 61.1446V50.1146H247.296V44.9345H250.243V39.3525H257.076V44.9345H261.988V50.1146H257.076V60.2962C257.076 62.6183 257.701 63.9133 260.648 63.9133H261.943V69.0487C261.184 69.406 259.666 69.6739 257.835 69.6739C252.699 69.6739 250.243 66.7266 250.243 61.1446Z",
    fill: "#181818"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.309 79.5429C266.97 79.5429 265.585 79.141 264.96 78.873V73.6929H266.344C268.756 73.6929 270.23 73.1571 271.748 69.0934L272.239 67.8877L262.951 44.9345H270.23L274.829 57.7061L275.722 61.3232L276.705 57.7061L281.081 44.9345H288.047L277.866 70.835C275.32 77.3994 272.82 79.5429 268.309 79.5429Z",
    fill: "#181818"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M294.893 68.9603V38.5942H315.479V41.9434H299.001V51.5445H313.827V54.8937H299.001V65.6111H315.479V68.9603H294.893Z",
    fill: "#181818"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M320.57 68.9603V45.248H324.5V48.4632C326.107 45.9625 328.697 44.6674 331.823 44.6674C336.87 44.6674 339.861 47.6147 339.861 53.1074V68.9603H335.932V53.9112C335.932 50.3387 334.324 48.0166 330.752 48.0166C326.822 48.0166 324.5 51.5445 324.5 54.9383V68.9603H320.57Z",
    fill: "#181818"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M346.661 62.1279V48.3739H343.356V45.248H346.661V39.7999H350.591V45.248H355.815V48.3739H350.591V62.1279C350.591 64.9859 351.439 66.3256 354.922 66.3256H355.726V69.1389C355.28 69.3622 354.297 69.4961 353.181 69.4961C348.76 69.4961 346.661 67.1294 346.661 62.1279Z",
    fill: "#181818"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M359.557 68.9603V45.248H363.487V48.9098C365.094 46.0071 367.64 44.6674 370.498 44.6674C371.435 44.6674 372.284 44.8907 372.73 45.248V48.7758C372.06 48.5525 371.212 48.4632 370.274 48.4632C365.541 48.4632 363.487 51.4105 363.487 55.6975V68.9603H359.557Z",
    fill: "#181818"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M377.287 79.3205C376.394 79.3205 375.456 79.0972 374.965 78.9632V75.9266H376.171C379.074 75.9266 379.877 75.3461 382.199 70.032L383.003 68.2011L373.313 45.248H377.555L383.986 60.9222L385.057 64.0928L386.129 60.9222L392.381 45.248H396.4L385.325 72.0862C382.959 77.8022 381.396 79.3205 377.287 79.3205Z",
    fill: "#181818"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 109,
    rx: 28.9184,
    fill: "url(#paint0_linear_793_10019)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9115 30.9663H40.1206V65.0238H68.9115V30.9663ZM35.2051 26.0508V69.9394H73.827V26.0508H35.2051Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4269 39.0604L35.2051 26.0508V69.9394L59.4269 82.949V39.0604Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_793_10019",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD954A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.6c168f7b2a7fcd9a9c669deab508fc8b.svg";
export { ForwardRef as ReactComponent };